import { Empresa } from './empresa';

export class ClienteBoleta {
    constructor(
        public id: number,
        public nombres: string,        
        public apellidos: string,      
        public nombreCompleto: string, 
        public email: string,          
        public telefono: string,    
        public activo: boolean,         
        public eliminado: boolean,      
        public dpi:string,
        public nit:string,
        public noEsClienteContinental: boolean,
        //Relaciones
        public EmpresaId: number,
    ){}

    objetoNombreCompleto: any = {};
    objetoDpi: any = {};
    
    Empresa: Empresa;

}